// extracted by mini-css-extract-plugin
export var customBlockquote = "styles-module--custom-blockquote--457f9";
export var customBlockquoteAuthor = "styles-module--custom-blockquote-author--c1f3b";
export var customBlockquoteContent = "styles-module--custom-blockquote-content--2b75d";